// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"src-pages-HxTaxBureau-__index__formWrapper--1v3nT"};